import React from "react";
import classnames from "classnames";

import "./StatusBox.scss";

interface StatusBoxProps {
  type?: string;
  status?: string;
}

const StatusBox = ({ type, status }: StatusBoxProps) => {
  return (
    <span className={classnames(`status-box ${type}-status-box`)}>
      {status}
    </span>
  );
};

export const statusBoxStatuses = {
  primary: "primary",
  secondary: "secondary",
  success: "success",
  danger: "danger",
  warning: "warning",
  info: "info",
  light: "light",
  dark: "dark",
  complete: "complete",
  pending: "pending",
};

export default StatusBox;
